import clsx from 'clsx';
import { useEffect, useState } from 'react';

type GlobalAlertProps = {
  title: string;
  message: string;
  alertType?: 'light' | 'dark' | 'critical' | '';
  onClose: () => unknown;
};

/**
 * AlertType:
 * light = upcoming
 * dark = in-progress
 * critical = in-progress & unplanned
 */
export default function GlobalAlert({ title, message, alertType, onClose }: GlobalAlertProps) {
  let [alertTitle, setAlertTitle] = useState(title);

  useEffect(() => {
    switch (alertType) {
      case 'light':
        setAlertTitle('Upcoming Maintenance: ' + title);
        break;
      case 'dark':
        setAlertTitle('Currently in Maintenance: ' + title);
        break;
      case 'critical':
        setAlertTitle('Outage: ' + title);
        break;
    }
  }, [alertType]);

  return (
    <div
      className={clsx({
        'nsw-sitewide-message js-sitewide-message': 1,
        'nsw-sitewide-message--light': !alertType || alertType === 'light',
        'nsw-sitewide-message--critical': alertType === 'critical',
        'nsw-sitewide-message--dark': alertType === 'dark',
      })}
      role="alert"
    >
      <div className="nsw-sitewide-message__wrapper">
        <div className="nsw-sitewide-message__content">
          <h2 className="nsw-sitewide-message__title">{alertTitle}</h2>
          {message && <p>{message}</p>}
        </div>
        <button type="button" className="nsw-sitewide-message__close" onClick={onClose}>
          <i className="material-icons nsw-material-icons" tabIndex={-1} aria-hidden="true">
            close
          </i>
          <span className="sr-only">Close message</span>
        </button>
      </div>
    </div>
  );
}
